import { useNavigate } from "@tanstack/react-router"
import { useCreateTenantMutation } from "./api"
import { useRedirectAfterLogin } from "@/auth"
import { ApiFormWrapper, FormError, FormInput, FormSubmitButton } from "@/form"

export default function TenantCreateForm() {
  const [createTenant] = useCreateTenantMutation()
  const { getRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()

  const handleSuccess = () => navigate({ to: getRedirectUrl(), replace: true })

  return (
    <ApiFormWrapper
      defaultValues={{ name: "" }}
      action={createTenant}
      onSuccess={handleSuccess}
    >
      <FormInput name="name" autoFocus required className="mb-3 w-full" />
      <FormError />
      <FormSubmitButton>Create Workspace</FormSubmitButton>
    </ApiFormWrapper>
  )
}
